import { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import "./FaqContact.scss";
import FaqContactModal from "app/pages/Faq/FaqFooter/FaqContact/FaqContactModal";
import { ButtonLink } from "app/components/ui/ButtonLink/ButtonLink";
import { Button } from "app/components/ui/Button/Button";
import { CallFilledIcon, MailStrokeIcon } from "app/icons/profile";
import {
	sendTagOnFaqShowPhoneButtonClick,
	sendTagOnFaqWriteUsButtonClick,
} from "app/utils/analytics";

const FaqContact = ({
	hideContactByPhone = false,
	hideContactByMail = false,
	helpContactUrl,
	servicesPhone = {},
	preSalesPlanningUrl,
	afterSalesPlanningUrl,
}) => {
	const [showModal, setShowModal] = useState(false);

	const handlePhoneClick = useCallback(() => {
		sendTagOnFaqShowPhoneButtonClick();
		setShowModal(true);
	}, [showModal]);

	const handleWriteClick = useCallback(() => {
		sendTagOnFaqWriteUsButtonClick();
	}, []);

	const handleCloseModal = useCallback(() => {
		setShowModal(false);
	}, [showModal]);

	return !hideContactByPhone || !hideContactByMail ? (
		<div className="faq-contact">
			<div className="faq-contact__title">
				<FormattedMessage id="faq.contact.title" />
			</div>
			<div className="faq-contact__actions">
				{!hideContactByPhone && (
					<Button
						variant="primary"
						size="lg"
						startIcon={<CallFilledIcon />}
						className="faq-contact__button"
						onClick={handlePhoneClick}
					>
						<FormattedMessage id="faq.contact.phone.button.label" />
					</Button>
				)}

				<ButtonLink
					variant="primary"
					size="lg"
					startIcon={<MailStrokeIcon className="icon" />}
					to={{ pathname: helpContactUrl }}
					className="faq-contact__button"
					onClick={handleWriteClick}
				>
					<FormattedMessage id="faq.contact.write.button.label" />
				</ButtonLink>
			</div>
			<FaqContactModal
				isOpen={showModal}
				servicesPhone={servicesPhone}
				onClose={handleCloseModal}
				preSalesPlanningUrl={preSalesPlanningUrl}
				afterSalesPlanningUrl={afterSalesPlanningUrl}
			/>
		</div>
	) : null;
};

FaqContact.propTypes = {
	helpContactUrl: PropTypes.string,
	hideContactByPhone: PropTypes.bool,
	hideContactByMail: PropTypes.bool,
	servicesPhone: PropTypes.object,
	preSalesPlanningUrl: PropTypes.string,
	afterSalesPlanningUrl: PropTypes.string,
};

export default FaqContact;
